import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/main.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局事件总线（用于数据范围切换时刷新页面）
Vue.prototype.$bus = new Vue()

// 应用主题：启动即按 localStorage 偏好设置 <html data-theme>，避免刷新闪白
document.documentElement.setAttribute('data-theme', store.state.theme || 'light')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
